import useIsAutomatedBreaksFeatureFlagEnabled from '@web/automatedBreaks/hooks/useIsAutomatedBreaksFeatureFlagEnabled';
import BreaksV1 from '@web/settings/components/schedule/BreaksV1/BreaksV1';
import Breaks from '@web/settings/components/schedule/Breaks/Breaks';

const BreaksSection = () => {
  const automatedBreaksFeatureEnabled = useIsAutomatedBreaksFeatureFlagEnabled();

  if (!automatedBreaksFeatureEnabled) {
    return <BreaksV1 />;
  }

  return <Breaks />;
};

export default BreaksSection;
